<template src="./template.html"></template>

<script>
import { mapState } from 'vuex'
import LegalFooter from '@/components/layout/LegalFooter'
import MetaHeader from '@/components/layout/MetaHeader'

export default {
  name: 'MetaPage',
  components: {
    MetaHeader,
    LegalFooter,
  },
  props: {
    customTitle: String,
  },
  computed: {
    ...mapState('auth', [ 'settings' ]),
  },
}
</script>
